import { observer } from "mobx-react-lite"

import type { WithdrawStore } from "@/domains/lock-page/withdraw-store"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"

interface WithdrawExpiredProps {
  store: WithdrawStore
}

export const WithdrawExpired = observer(({ store }: WithdrawExpiredProps) => {
  return (
    <ShortMessageBox variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
      <BodySM className="text-t200">Your veSCALE has expired. Checking if reset is required...</BodySM>
    </ShortMessageBox>
  )
})

